import withIsVisibleHOC from "@client/hocs/withIsVisible";
import Login from "@client/widgets/Login/container";

export default withIsVisibleHOC(Login);
